import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function FullPageQuizMobileNavigationV2({
  onNextClick,
  onSubmit,
  isNextDisabled,
  isSubmitDisabled,
  isLastStep
}) {
  return (
    <div className="FullPageQuizMobileNavigationV2 primary pv3 ph2 bg-white">
      <div className="tr w-100 flex justify-center">
        <button
          type="button"
          onClick={isLastStep ? onSubmit : onNextClick}
          disabled={isNextDisabled || (isLastStep && isSubmitDisabled)}
          className={classnames(
            'button font-16 fw-medium w-100 mh6 pv3 bg-blue-500 white',
            {
              'light-gray': isNextDisabled
            }
          )}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

FullPageQuizMobileNavigationV2.propTypes = {
  onNextClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isNextDisabled: PropTypes.bool.isRequired,
  isSubmitDisabled: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired
};
